// GoTrue requires a non-null unique email, so the Nest lifecycle writes a
// synthetic <phone>@phone.local for phone-only accounts. It's not a real address
// — the UI treats it as absent (hidden on display, empty in the change-email form).
const PLACEHOLDER_EMAIL_DOMAIN = "@phone.local";

/** True when the email is missing or the synthetic <phone>@phone.local placeholder. */
export function isPlaceholderEmail(email: string | null | undefined): boolean {
  return !email || email.toLowerCase().endsWith(PLACEHOLDER_EMAIL_DOMAIN);
}

/** The email to show or pre-fill: the real address, or "" for a placeholder/missing one. */
export function displayEmail(email: string | null | undefined): string {
  return isPlaceholderEmail(email) ? "" : (email as string);
}
